import React, { useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Alert } from 'reactstrap';
import Select from 'react-select';
import { httpClient } from '../../../api/httpClient';
import { urlListarColoresMotos } from '../api/urls';

const styles = {
    label: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#000000',
        margin: 0
    }
};

/**
 * Card de Datos Complementarios del Vehículo (1 elemento por renglón).
 */
const DatosComplementariosMoto = ({
    placa,
    onChangePlaca,
    motor,
    onChangeMotor,
    chasis,
    onChangeChasis,
    color,
    onChangeColor,
    valorAsegurado,
    onChangeValorAsegurado,
    polizaAutoVigente,
    onChangePolizaAutoVigente,
    esPlanSafe,
    errores
}) => {
    const [listaColores, setListaColores] = useState([]);
    const [cargandoColores, setCargandoColores] = useState(false);

    useEffect(() => {
        var cargarColores = async () => {
            setCargandoColores(true);
            try {
                var res = await httpClient.get(urlListarColoresMotos);
                if (res && res.transaccion && Array.isArray(res.colores)) {
                    var opts = res.colores.map(function(item) {
                        return {
                            value: item.colCodigoCore || item.codigo || item.colNombre,
                            label: item.colNombre || item.nombre
                        };
                    });
                    setListaColores(opts);
                } else {
                    setListaColores([
                        { value: 'NEGRO', label: 'NEGRO' },
                        { value: 'BLANCO', label: 'BLANCO' },
                        { value: 'ROJO', label: 'ROJO' },
                        { value: 'AZUL', label: 'AZUL' },
                        { value: 'GRIS', label: 'GRIS' },
                        { value: 'PLATA', label: 'PLATA' },
                        { value: 'VERDE', label: 'VERDE' },
                        { value: 'AMARILLO', label: 'AMARILLO' },
                        { value: 'NARANJA', label: 'NARANJA' }
                    ]);
                }
            } catch (err) {
                setListaColores([
                    { value: 'NEGRO', label: 'NEGRO' },
                    { value: 'BLANCO', label: 'BLANCO' },
                    { value: 'ROJO', label: 'ROJO' },
                    { value: 'AZUL', label: 'AZUL' },
                    { value: 'GRIS', label: 'GRIS' },
                    { value: 'PLATA', label: 'PLATA' },
                    { value: 'VERDE', label: 'VERDE' },
                    { value: 'AMARILLO', label: 'AMARILLO' },
                    { value: 'NARANJA', label: 'NARANJA' }
                ]);
            } finally {
                setCargandoColores(false);
            }
        };
        cargarColores();
    }, []);

    var err = errores || {};

    return (
        <Card className="shadow-sm mb-4">
            <CardBody style={{ padding: '2rem' }}>
                <h4 style={{ fontWeight: 'bold', color: '#000000', marginBottom: '1.5rem' }}>
                    Datos del Vehículo
                </h4>

                {/* Renglón 1: Placa */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Placa</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <input 
                            type="text"
                            className={"form-control" + (err.placa ? " is-invalid" : "")}
                            placeholder="Ej: ABC1234 o M12345"
                            value={placa || ''}
                            onChange={(e) => {
                                if (onChangePlaca) {
                                    onChangePlaca(e.target.value.toUpperCase().replace(/\s+/g, ''));
                                }
                            }}
                            maxLength={8}
                        />
                        {err.placa && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> {err.placaMsg || "Para iniciar la emisión es obligatorio registrar la placa del vehículo."}
                            </span>
                        )}
                    </Col>
                </Row>

                {/* Renglón: Color */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Color</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <Select 
                            value={color}
                            onChange={(val) => {
                                if (onChangeColor) {
                                    onChangeColor(val);
                                }
                            }}
                            options={listaColores}
                            placeholder="Seleccione el color de la moto..."
                            isLoading={cargandoColores}
                            isSearchable={true}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        />
                        {err.color && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Por favor seleccione el color.
                            </span>
                        )}
                    </Col>
                </Row>
                
                {/* Renglón: Valor asegurado */}
                <Row className="mb-3 align-items-center">
                      <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Valor Asegurado (Suma Asegurada) *</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>

                        <input
                            type="number"
                        className={"form-control" + ((err.sinValorAsegurado || err.valorAseguradoSuperaLimite || err.valorAseguradoMenorPermitido) ? " is-invalid" : "")}
                            placeholder=" Monto entre $1000 y $100000"
                            min="1000"
                            max={100000}
                            step="10"
                            value={valorAsegurado}
                            onChange={(e) => {
                                if (onChangeValorAsegurado) {
                                    onChangeValorAsegurado(e.target.value);
                                }
                            }}
                        />
                        {err.sinValorAsegurado && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Por favor ingrese el valor asegurado válido.
                            </span>
                        )}
                        {err.valorAseguradoSuperaLimite && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> El valor no puede superar el límite del $100000.
                                    </span>
                        )}

                        {err.valorAseguradoMenorPermitido && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.85rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> El valor no puede ser inferior a $1000.
                                    </span>
                        )}
                        <small className="text-muted d-block mt-1"> Mínimo: $1,000 | Máximo: $100,000</small>
                    </Col>
                </Row>
                {/* Regla Especial AIG Moto SAFE (Gama Baja) */}
                {esPlanSafe && (
                    <div className="mt-4 pt-3 border-top">
                        <Alert color="warning" className="mb-3">
                            <i className="fa fa-info-circle mr-2"></i>
                            <strong>Regla de Emisión AIG Moto SAFE:</strong> Este producto aplica exclusivamente para clientes con póliza de Auto vigente en AIG. Se requiere ingresar el número de póliza previa para solicitar la aprobación técnica de la línea.
                        </Alert>
                        <Row className="mb-2 align-items-center">
                            <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                                <h5 style={styles.label}>Póliza de Auto Previa (*)</h5>
                            </Col>
                            <Col lg={8} md={8} sm={12}>
                                <input 
                                    type="text"
                                    className={"form-control" + (err.polizaAuto ? " is-invalid" : "")}
                                    placeholder="Ej: POL-AUTO-2024-88492 o No. Compra"
                                    value={polizaAutoVigente || ''}
                                    onChange={(e) => {
                                        if (onChangePolizaAutoVigente) {
                                            onChangePolizaAutoVigente(e.target.value.toUpperCase());
                                        }
                                    }}
                                />
                                {err.polizaAuto && (
                                    <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                        <i className="fa fa-exclamation-circle mr-1"></i> El número de póliza de auto previa es obligatorio para AIG Moto SAFE.
                                    </span>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default DatosComplementariosMoto;
